import { connect } from 'react-redux'
import { pick } from 'immutadot'
import Item from './Item.jsx'
import {
    isItemDisplayable,
    retrieveValueFromToolbar,
} from '../../../../redux/availableActions/selectors'

const mapStateToProps = (state, ownProps) => ({
    isItemDisplayable: () => isItemDisplayable(state, ownProps),
    isSelected: retrieveValueFromToolbar(state, ownProps, 'isSelected', false),
    title: retrieveValueFromToolbar(state, ownProps, 'title', ''),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: () => {
        if(typeof(ownProps.action) === "function")
        {
            dispatch(ownProps.action(pick(ownProps, ['parameters', 'name'])))
        }
    }
})

export const ItemContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Item)
